module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Tags"
    }
  }, [(_vm.loading) ? _c('Loader') : _c('section', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop is-6-fullhd is-offset-3-fullhd"
  }, [_c('section', {
    staticClass: "flex-space-between align-items-center"
  }, [_c('h2', {
    staticClass: "title is-2 pt-0 mt-0"
  }, [_vm._v("Tagged Comments "), _c('span', {
    staticClass: "tag",
    style: ({
      'background-color': '#' + _vm.tag.color
    })
  }, [_vm._v(_vm._s(_vm.tag.title))])]), _vm._v(" "), _c('a', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        _vm.download()
      }
    }
  }, [_vm._v("Download")])]), _vm._v(" "), _c('section', {
    staticClass: "d-flex container"
  }, _vm._l((_vm.comments), function(comment) {
    return _c('ReadOnlyComment', {
      key: comment.id,
      staticClass: "mb-3 mr-2",
      attrs: {
        "videoID": comment.video,
        "videoTitle": comment.video_title,
        "userID": _vm.userID,
        "elements": comment.elements,
        "id": comment.id,
        "replies": comment.replies,
        "replies_editing": comment.replies_editing,
        "user": comment.user,
        "body": comment.body,
        "created_on": comment.created_on,
        "start_time": comment.start_time,
        "end_time": comment.end_time,
        "tags": comment.tags,
        "scores": comment.scores
      }
    })
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-45b19442"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaggedComments.vue
// module id = 1020
// module chunks = 0